var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "transition",
    {
      attrs: {
        name: _vm.animation,
        mode: "out-in",
        appear: "",
        "appear-active-class": _vm.transition.enterClass,
        "enter-active-class": _vm.transition.enterClass,
        "leave-active-class": _vm.transition.leaveClass,
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.realSelected,
              expression: "realSelected",
            },
          ],
          class: _vm.classObject,
          attrs: {
            role: "tabpanel",
            "aria-labelledby": _vm.label,
            "aria-hidden": _vm.hidden,
          },
        },
        [_vm._t("default")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }